import { Flex, Container, Card, styled } from '@grupoboticario/flora-react';

export const styles = {
  LinkCard: styled(Flex, {
    backgroundColor: '$nonInteractiveAltEmphasis',
    borderRadius: '$small',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '$4',
    width: '100%',

    '@tablet': {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  }),
  Challenges: styled(Container, {
    display: 'flex',
    gap: '$2',
    justifyContent: 'center',
    padding: '0',
    flexWrap: 'wrap',
  }),

  ChallengesCard: styled(Card, {
    backgroundColor: '$backgroundSecondary',
    margin: '$1 $6',
    textAlign: 'left',
    '&[data-complete="true"]': {
      backgroundColor: 'color-mix(in srgb, $success-standard, white 90%);',
    },
  }),

  ChallengesCardWrapper: styled(Card, {
    width: '100%',
  }),

  ChallengeWrapper: styled(Flex, {
    alignItems: 'center',
    flexDirection: 'column',
    gap: '$4',
    padding: '$12 0',
  }),

  CardsWrapper: styled(Container, {
    display: 'grid',
    gap: '$4',
    padding: '$10 0',

    '@tablet': {
      gridTemplateColumns: '50% 1fr',
    },
  }),

  ResellerProgress: styled(Card, {
    backgroundColor: '$backgroundSecondary',
    display: 'flex',
    flexDirection: 'column',
    gap: '$4',
    padding: '$4',
    textAlign: 'center',
    alignSelf: 'flex-start',
  }),

  RemainingValue: styled(Card, {
    backgroundColor: '$backgroundSecondary',
    padding: '$3 $4',
  }),
  Wrapper: styled(Flex, {
    margin: '$4',
    flexDirection: 'column',
    gap: '$4',
  }),
  Message: styled(Flex, {
    marginLeft: '$1',
    flexDirection: 'column',
    gap: '$4',
  }),
  Items: styled(Flex, {
    marginLeft: '$4',
    flexDirection: 'column',
    gap: '$2',
  }),
  CardInfo: styled(Flex, {
    textAlign: 'left',
    '@tablet': {
      alignItems: 'flex-start',
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  }),
};

export default styles;
